
import React from "react";
import "../styles/FeaturedPlaces.css";
import place1 from "../assets/leh.webp";
import place2 from "../assets/goa.webp";
import place3 from "../assets/sikkim.webp";
import place4 from "../assets/abudhabi.webp";
import place5 from "../assets/dubaiuae.webp";
import ad from "../assets/RuPayvideo.mp4";

const FeaturedPlaces = () => {
  return (
    <div className="featured-section">

      {/* Ad banner */}
      <div className="ad-banner">
        <a
          href="https://www.rupay.co.in/credit-cards?utm_source=perfpartner&utm_medium=cpapplynow&utm_campaign=rupay-iplsurround&utm_id=sm-creditcard-rupay2026-creditcard-RS-static-blue-english-static-IA-424_"
          target="_blank"
          rel="noopener noreferrer"
        >
          <video
            src={ad}
            autoPlay
            muted
            loop
            playsInline
            controls
            className="ad-video"
          />
        </a>
      </div>

      {/* Heading */}
      <div className="featured-header">
        <h2 className="section-title">Explore Popular Destinations</h2>
        <h3 className="section-subtitle">
          Handpicked places loved by travellers around the world.
        </h3>
      </div>

      {/* Grid */}
      <div className="featured-grid">

        <div className="place-card">
          <img src={place1} alt="Leh" />
          <div className="place-info">
            <span>Leh</span>
            <h3>India</h3>
          </div>
        </div>

        <div className="place-card">
          <img src={place2} alt="Goa" />
          <div className="place-info">
            <span>Goa</span>
            <h3>India</h3>
          </div>
        </div>

        <div className="place-card">
          <img src={place3} alt="Sikkim" />
          <div className="place-info">
            <span>Sikkim</span>
            <h3>India</h3>
          </div>
        </div>

        <div className="place-card">
          <img src={place4} alt="Abu Dhabi" />
          <div className="place-info">
            <span>Abu Dhabi</span>
            <h3>UAE</h3>
          </div>
        </div>

        <div className="place-card">
          <img src={place5} alt="Dubai" />
          <div className="place-info">
            <span>Dubai</span>
            <h3>UAE</h3>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FeaturedPlaces;
